const processData = (data, stokists) => {
  // Check if data array or stokists array is empty
  if (
    !Array.isArray(data) ||
    !Array.isArray(stokists) ||
    data.length === 0 ||
    stokists.length === 0
  ) {
    const result = [];
    for (let month = 1; month <= 12; month++) {
      const monthlyData = { month, monthlyTotal: 0 };
      stokists.forEach(({ name }) => {
        monthlyData[name] = 0;
      });
      result.push(monthlyData);
    }
    return result;
  }

  // Initialize objects to store totals
  const monthlyTotalsByStokist = {};
  const monthlyTotalSales = {};
  const yearlyTotalSalesByStokist = {};

  // Initialize monthly and yearly totals for each stokist
  stokists.forEach(({ _id }) => {
    monthlyTotalsByStokist[_id] = {};
    yearlyTotalSalesByStokist[_id] = 0;
    for (let month = 1; month <= 12; month++) {
      monthlyTotalsByStokist[_id][month] = 0;
    }
  });

  // Loop through the data to calculate monthly and yearly totals for each stokist
  data.forEach((entry) => {
    const { month, totalAmount, year, stokist_id } = entry;

    if (!stokist_id) {
      console.warn(`Entry is missing stokist_id:`, entry);
      return;
    }

    if (!monthlyTotalsByStokist[stokist_id]) {
      console.warn(
        `Stokist ID ${stokist_id} does not exist in monthlyTotalsByStokist`
      );
      return;
    }

    if (monthlyTotalsByStokist[stokist_id][month] !== undefined) {
      monthlyTotalsByStokist[stokist_id][month] += totalAmount;
    } else {
      console.warn(
        `Month ${month} does not exist for stokist ID ${stokist_id}`
      );
    }

    if (yearlyTotalSalesByStokist[stokist_id] !== undefined) {
      yearlyTotalSalesByStokist[stokist_id] += totalAmount;
    } else {
      console.warn(
        `Stokist ID ${stokist_id} does not exist in yearlyTotalSalesByStokist`
      );
    }

    if (!monthlyTotalSales[month]) {
      monthlyTotalSales[month] = 0;
    }
    monthlyTotalSales[month] += totalAmount;
  });

  // Calculate yearly total sales for all stokists
  const yearlyTotalSales = {};
  const years = data.map((entry) => entry.year);
  const minYear = Math.min(...years);
  const maxYear = Math.max(...years);

  for (let year = minYear; year <= maxYear; year++) {
    yearlyTotalSales[year] = data
      .filter((entry) => entry.year === year)
      .reduce((total, entry) => total + entry.totalAmount, 0);
  }

  // Initialize an array to store the final result
  const result = [];

  // Loop through each month to create the result array
  for (let month = 1; month <= 12; month++) {
    const monthlyData = { month, monthlyTotal: monthlyTotalSales[month] || 0 };

    // Add total sales for each stokist for the current month
    stokists.forEach(({ _id, name }) => {
      if (
        monthlyTotalsByStokist[_id] &&
        monthlyTotalsByStokist[_id][month] !== undefined
      ) {
        monthlyData[name] = monthlyTotalsByStokist[_id][month];
      } else {
        monthlyData[name] = 0;
      }
    });

    result.push(monthlyData);
  }

  return result;
};

export default processData;

export function generateMonthlyComparison(previousYearData, currentYearData) {
  // Initialize an array to store the comparison data
  const comparisonData = [];

  // Loop through each month in the current year data
  currentYearData.forEach((currentMonth, index) => {
    // Initialize an object to store the comparison data for the current month
    const monthComparison = {
      month: index + 1, // Month index starts from 0, so add 1 to match the actual month number
      previousYear: 0,
      currentYear: currentMonth.monthlyTotal || 0, // Set current year value to 0 if not provided
    };

    // Find the corresponding month data in the previous year data
    const previousMonth = previousYearData.find(
      (month) => month.month === index + 1
    );

    // If previous year data exists for the current month, assign its value
    if (previousMonth) {
      monthComparison.previousYear = previousMonth.monthlyTotal || 0;
    }

    // Push the comparison data for the current month to the comparison data array
    comparisonData.push(monthComparison);
  });

  // Return the array of comparison data
  return comparisonData;
}

export function calculateYearlyTotal(data) {
  const yearlyTotalSales = {};
  // console.log('data is []',data)
  if (data.length === 0) {
    return 0;
  }
  for (
    let year = Math.min(...data.map((entry) => entry.year));
    year <= Math.max(...data.map((entry) => entry.year));
    year++
  ) {
    yearlyTotalSales[year] = data
      .filter((entry) => entry.year === year)
      .reduce((total, entry) => total + entry.totalAmount, 0);
  }
  return yearlyTotalSales;
}
